import { Injectable } from '@angular/core';
import { createEffect, ofType } from '@ngrx/effects';
import { from } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { TranslatableEffect } from '../../i18n/TranslatableEffects';
import { NotesService } from '../../services/notes.service';
import { ToastActions } from '../toast/toast.actions';
import { TodoActions } from './todo.actions';

@Injectable()
export class TodoEffects extends TranslatableEffect {
  loadClients$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TodoActions.saveTodo),
      switchMap(({ todo }) =>
        this.notesService.addTodoType(todo).pipe(
          mergeMap((newTodo) =>
            from([
              TodoActions.saveTodoSucceeded({ todo: newTodo }),
              ToastActions.showInfoMessage({
                summary: this.translate('saved'),
                detail: this.translate('noteTodoSaved'),
              }),
            ]),
          ),
          catchError((error: unknown) =>
            from([
              TodoActions.saveTodoFailed({ error }),
              ToastActions.showErrorMessage({
                summary: this.translate('errorWhileSavingTodoItem'),
                detail: '',
                error,
              }),
            ]),
          ),
        ),
      ),
    ),
  );

  increaseTodoCount$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TodoActions.increaseTodoCount),
        switchMap(() => {
          this.notesService.increaseTodosCount();
          return [];
        }),
      ),
    { dispatch: false },
  );

  constructor(private notesService: NotesService) {
    super('TodoEffects');
  }
}
